<template>
  <DSSidebarGroupChild
    :icon="isDashboard ? GripVerticalIcon : child.icon || LayoutDashboardIcon"
    :label="child.label || ''"
    :active="!!child.active"
    :as="isEditMode ? 'div' : RouterLink"
    :to="isEditMode ? undefined : { name: child.route, params: child.routeParams }"
    :data-refid="childRefId"
    :data-handle="isDashboard || undefined"
    class="group"
    :class="{
      'opacity-50': isEditMode,
      'bg-white/15 font-bold text-primary-foreground': !!child.active,
      'text-primary-foreground/80 hover:bg-white/10 hover:text-primary-foreground': !child.active,
    }"
    :is-mobile
    @click="emit('click')"
  >
    <template #label>
      <DashboardRename
        v-model="editing"
        :label="child.label || ''"
        @save="handleSave"
      >
        <span class="min-w-0 flex-1 truncate">{{ child.label }}</span>
      </DashboardRename>
    </template>
    <template
      v-if="isDashboard"
      #trailing
    >
      <DashboardActions
        :disabled="isEditMode"
        :child
        :side="isMobile ? 'bottom' : undefined"
        :align="isMobile ? 'end' : undefined"
        :open-icon="isMobile ? ChevronDownIcon : undefined"
        trigger-class="-mr-1.5 size-7 rounded-ds-sm text-white/70 hover:bg-white/10"
        @click="emit('click')"
        @rename="handleRename"
      />
    </template>
  </DSSidebarGroupChild>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { RouterLink } from 'vue-router'
import { upperFirst } from 'lodash'

import { NavigationItem } from '@types'

import { DSSidebarGroupChild } from '@ds'

import { ChevronDownIcon, GripVerticalIcon, LayoutDashboardIcon } from '@lucide/vue'

import DashboardActions from './DashboardActions.vue'
import DashboardRename from './DashboardRename.vue'

type Props = {
  child: NavigationItem
  isDashboard?: boolean
  isEditMode?: boolean
  isMobile?: boolean
}

const { child, isDashboard, isEditMode } = defineProps<Props>()

const emit = defineEmits<{
  click: []
}>()

const childRefId = computed(() =>
  `panelMenuNodeChild${child.label?.split(' ').map(item => upperFirst(item)).join('')}`)

const editing = ref(false)

const handleRename = () => {
  editing.value = true
}

const handleSave = (value: string) => {
  child.update?.(value)
}
</script>
